export default {"src":"/_next/static/media/budget.5cc392e7.svg","height":398,"width":400};